import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TPeriodDM from './TPeriodDM'
import TBookDM from './TBookDM'
import TK2UserLookupDM from './TK2UserLookupDM'
import TEmployedPersonDM from './TEmployedPersonDM'
import TPrPeriodDM from './TPrPeriodDM'
import TTextDM from './TTextDM'
import TMarketingActivityTypeDM from './TMarketingActivityTypeDM'
import TWorkflowProcessDM from './TWorkflowProcessDM'
import TTradingPartnerDM from './TTradingPartnerDM'
import TWarehouseDM from './TWarehouseDM'
import TCommentDM from './TCommentDM'
import TPrTransferComponentDM from './TPrTransferComponentDM'
import TPrDefinitionComponentDM from './TPrDefinitionComponentDM'
import TPrInputComponentDM from './TPrInputComponentDM'
import TPrOutputComponentDM from './TPrOutputComponentDM'
import TPrHistoryComponentDM from './TPrHistoryComponentDM'
import TPrEmployeeDocumentDM from './TPrEmployeeDocumentDM'
import TExternalDocumentItemDM from './TExternalDocumentItemDM'
import TWorkflowProcessAsItemDM from './TWorkflowProcessAsItemDM'
import TLanguageMemoTranslationDM from './TLanguageMemoTranslationDM'
import TAttachedDocumentDM from './TAttachedDocumentDM'
import TOldNoteDM from './TOldNoteDM'

export default class TPrPersonDocumentDM extends Data {
	public static className = 'TPrPersonDocumentDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	FirstName?: string
	Surname?: string
	EmployeePersonalNumber?: string
	ConfirmationLogId?: number
	CreationLogId?: number
	CalculationLogId?: number
	PrecalculationLogId?: number
	Number?: number
	ConfirmedOn?: Date
	PrComponentCreatedOn?: Date
	CalculatedOn?: Date
	PrecalculatedOn?: Date
	RightGroupId?: number
	ChangedOn?: Date
	TimeStamp?: string
	RID?: number
	RecordID?: number
	BookmarkImgCalc?: string
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	DocumentNumberCalc?: number
	IsItemCompleteCalc?: string
	PreviousPeriodCloseIdCalc?: number
	PrecalculationPassedIdCalc?: number
	FirstPrecalculationDoneIdCalc?: number
	EditAfterPrecalculationIdCalc?: number
	PrecalculationConfirmationIdCalc?: number
	AdvanceGeneratePassedIdCalc?: number
	GenerateAdvanceConfirmIdCalc?: number
	ComputeBitCalc?: number
	EditAfterCalculationIdCalc?: number
	PeriodIsClosedBitCalc?: number
	NewPrDocumentBitCalc?: number
	ComputeFlagsDateCalc?: Date
	ForEmptyPrEmploymentCalc?: number
	AchieAssessBaseSocAmountCalc?: number
	AchieAssessBaseHlthAmountCalc?: number
	AchievContribPensionAmountCalc?: number
	AgreementHourCalc?: number
	TextHeaderMemoCalc?: string
	TextFooterMemoCalc?: string
	LastCommentParamCalc?: string
	OwnAddressIdCalc?: number
	OwnAddressNameCalc?: string
	DocumentIdentificationCalc?: string
	BarcodeCalc?: string
	IsReversedExchangeRateViewCalc?: string
	RightGroupIdCalc?: number
	@Type(() => TPeriodDM)
	BusinessYearId?: TPeriodDM
	@Type(() => TBookDM)
	BookId?: TBookDM
	@Type(() => TK2UserLookupDM)
	ConfirmedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	PrComponentCreatedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	CalculatedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	PrecalculatedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TEmployedPersonDM)
	EmployedPersonId?: TEmployedPersonDM
	@Type(() => TPrPeriodDM)
	PeriodId?: TPrPeriodDM
	@Type(() => TPeriodDM)
	BusinessYearIdCalc?: TPeriodDM
	@Type(() => TTextDM)
	ConfirmedPeriodIdCalc?: TTextDM
	@Type(() => TTextDM)
	ConfirmedOrCanceledIdCalc?: TTextDM
	@Type(() => TTextDM)
	AdvanceGenerateStateIdCalc?: TTextDM
	@Type(() => TTextDM)
	PrecalculationStateIdCalc?: TTextDM
	@Type(() => TTextDM)
	ComputeStateIdCalc?: TTextDM
	@Type(() => TPrPeriodDM)
	ProcessedPeriodIdCalc?: TPrPeriodDM
	@Type(() => TTextDM)
	DocumentExistsCalc?: TTextDM
	@Type(() => TMarketingActivityTypeDM)
	ActivityTypeRIDCalc?: TMarketingActivityTypeDM
	@Type(() => TTextDM)
	ProcessStateIdCalc?: TTextDM
	@Type(() => TWorkflowProcessDM)
	CurrentProcessIdCalc?: TWorkflowProcessDM
	@Type(() => TTradingPartnerDM)
	OwnTradingPartnerIdCalc?: TTradingPartnerDM
	@Type(() => TPeriodDM)
	CurrentBusinessYearIdCalc?: TPeriodDM
	@Type(() => TWarehouseDM)
	CurrentWarehouseIdCalc?: TWarehouseDM
	@Type(() => TCommentDM)
	CommentChild?: TCommentDM[]
	@Type(() => TPrTransferComponentDM)
	CalculationPrComPeriodChild?: TPrTransferComponentDM[]
	@Type(() => TPrDefinitionComponentDM)
	PrComPermanentCompleteChild?: TPrDefinitionComponentDM[]
	@Type(() => TPrInputComponentDM)
	PrComponentInputCompleteChild?: TPrInputComponentDM[]
	@Type(() => TPrOutputComponentDM)
	PrComponentOutputCompleteChild?: TPrOutputComponentDM[]
	@Type(() => TPrOutputComponentDM)
	PrComOutEmployeeCompleteChild?: TPrOutputComponentDM[]
	@Type(() => TPrHistoryComponentDM)
	PrComHistoryProcessingPerChild?: TPrHistoryComponentDM[]
	@Type(() => TPrHistoryComponentDM)
	PrComHistEmpProcessPeriodChild?: TPrHistoryComponentDM[]
	@Type(() => TPrHistoryComponentDM)
	PrComHistoryValidPeriodChild?: TPrHistoryComponentDM[]
	@Type(() => TPrHistoryComponentDM)
	PrComHistEmpValidPeriodChild?: TPrHistoryComponentDM[]
	@Type(() => TPrEmployeeDocumentDM)
	PrBookDocumentChild?: TPrEmployeeDocumentDM[]
	@Type(() => TExternalDocumentItemDM)
	ExternalDocumentItemChild?: TExternalDocumentItemDM[]
	@Type(() => TWorkflowProcessAsItemDM)
	WorkflowProcessChild?: TWorkflowProcessAsItemDM[]
	@Type(() => TLanguageMemoTranslationDM)
	TextHeaderChild?: TLanguageMemoTranslationDM[]
	@Type(() => TLanguageMemoTranslationDM)
	TextFooterChild?: TLanguageMemoTranslationDM[]
	@Type(() => TAttachedDocumentDM)
	AttachedDocumentOldChild?: TAttachedDocumentDM[]
	@Type(() => TOldNoteDM)
	DeprecatedNoteOldChild?: TOldNoteDM[]
}